export { CardPlayerInfoEntity } from './card-player-info';
